// Issue #23 (rechten F3c): het bereik waarover de totalen van een antwoord gaan (envelop meta.scope =
// { partial, label, cells }). De gegenereerde client pakt de envelop uit en geeft enkel `data` terug, dus apiRequest
// legt meta.scope hier per pad vast; schermen tonen met <ScopeChip paths={[...]} /> "Deelbereik" naast hun totalen.
// Enkel gefilterde operaties met totalen sturen meta.scope mee; volle gebruikers krijgen { partial: false } en zien
// dus niets. Een pad zonder meta.scope wordt niet aangeraakt.

const byPath = new Map();
const listeners = new Set();
let version = 0;

// "v2/saa/allocation?x=1" en "/v2/saa/allocation" -> "v2/saa/allocation".
export function normalizeScopePath(path) {
  if (typeof path !== "string") return "";
  let p = path.split("?")[0];
  while (p.startsWith("/")) p = p.slice(1);
  if (p.startsWith("api/")) p = p.slice(4);
  return p;
}

export function recordScope(path, scope) {
  const key = normalizeScopePath(path);
  if (!key || !scope || typeof scope !== "object") return;
  const next = scope.partial
    ? { partial: true, label: scope.label || "deelbereik", cells: Array.isArray(scope.cells) ? scope.cells : [] }
    : null;
  const prev = byPath.get(key) || null;
  if (!prev && !next) return;
  if (prev && next && prev.cells.join("|") === next.cells.join("|")) return;
  if (next) byPath.set(key, next);
  else byPath.delete(key);
  version += 1;
  listeners.forEach((fn) => fn());
}

export function subscribeScope(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function getScopeVersion() {
  return version;
}

// Deelbereik voor de paden van een scherm (prefix-match), of null bij volledig bereik. Cellen samengevoegd, uniek.
export function getPartialScope(prefixes) {
  const list = (Array.isArray(prefixes) ? prefixes : [prefixes]).map(normalizeScopePath).filter(Boolean);
  const cells = new Set();
  let partial = false;
  for (const [key, info] of byPath) {
    if (!list.some((p) => key === p || key.startsWith(p.endsWith("/") ? p : `${p}/`))) continue;
    partial = true;
    info.cells.forEach((c) => cells.add(c));
  }
  return partial ? { partial: true, cells: [...cells].sort() } : null;
}

// Enkel voor tests.
export function resetScopeStore() {
  byPath.clear();
  version += 1;
  listeners.forEach((fn) => fn());
}
